<template>
    <div i="first-in-shop" v-cloak>
        <yd-popup v-model="firstDialog" position="center" :close-on-masker="false">
            <img src="/static/image/first_in_shop.png" class="vip-gift-img">
            <div class="vip-gift-desc">我们为您挑选了一些优惠热卖的礼包商品，购买礼包商品后可成为店铺会员，享受永久店铺购买特权以及相关会员权益。</div>
            <footer class="first-dialog-footer">
                <button @click="hiddenDialog">跳过</button>
                <button @click="goVipGift">去看看</button>
            </footer>
        </yd-popup>
    </div>
</template>
<style rel="stylesheet/scss" lang="scss">
    @import '~sass/root';
    [i="first-in-shop"]{
        .yd-popup-center {
            width: pxTorem(580px) !important;
            background: #fff;
            border-radius: pxTorem(16px);
            .yd-popup-content {
                border-radius: pxTorem(16px);
                .vip-gift-img {
                    width: 100%;
                }
                .vip-gift-desc {
                    padding: pxTorem(40px) pxTorem(50px) pxTorem(54px);
                    font-size: pxTorem(30px);
                    line-height: pxTorem(42px);
                    color: #333333;
                }
                .first-dialog-footer {
                    height: pxTorem(88px);
                    display: flex;
                    justify-content: space-between;
                    position: relative;
                    &::before {
                        content: "";
                        position: absolute;
                        top: 0;
                        width: 100%;
                        height: pxTorem(2px);
                        background: #dfdfdd;
                        transform: scale(1, 0.5);
                    }
                    button {
                        width: 50%;
                        color: #333333;
                        font-size: pxTorem(30px);
                        &:first-child {
                            position: relative;
                            &::before {
                                content: "";
                                position: absolute;
                                top: 0;
                                right: 0;
                                width: pxTorem(2px);
                                height: 100%;
                                background: #dfdfdd;
                                transform: scale(0.5, 1);
                            }
                        }
                    }
                }
            }
        }
    }
</style>
<script>

    import Vue from "vue";
    import {Popup} from 'vue-ydui/dist/lib.rem/popup';

    Vue.component(Popup.name, Popup);

    export default {
        data() {
            return {
                
            }
        },
        props:{
            firstDialog: {
				type: Boolean,
				default: false
			},
        },
        methods: {
            // 确认礼包弹窗
            giftPrompt() {
                tools.ajax({
                    url: "/api/gift/prompt/sure",
                    type: "GET",
                    ajaxData: {},
                    successFun: function(res) {
                    },
                    errorFun: function(error_data, status, headers, error_obj) {
                        tools.alert.error(error_data.error_msg);
                    }
                });
            },
            // 隐藏弹框
            hiddenDialog() {
                let userInfo = JSON.parse(localStorage.getItem('user')) || {};
                if(userInfo.user_type == 1 && userInfo.shop_has_show_vip_gift_prompt === 0){
                    userInfo.shop_has_show_vip_gift_prompt++;
                    localStorage.setItem('user', JSON.stringify(userInfo));
                }
                this.giftPrompt();
                this.$emit("hiddenFirstDialog", false);
            },
            // 去往礼包商品页面
            goVipGift() {
                this.hiddenDialog();
                this.openWin('/member_goods_list')
            }
        }
    }
</script>


// WEBPACK FOOTER //
// First_in_shop.vue?9bf52ae2